import { Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core';
import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';
import {
  GasPositioningPopup,
} from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.namespace';
import {
  GasDynamicPositioningPopupDirective,
} from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.directive';
import { GasPositioning } from '../../../utils/gas-positioning/gas-positioning.namespace';
import { GasPositioningService } from '../../../utils/gas-positioning/gas-positioning.service';
import { GasBrowserEventsService } from '../../../utils/gas-browser-event/gas-browser-events.service';
import {
  GAS_POSITIONING_CONFIG,
} from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.constant';
import { GasDatapickerCalendarComponent } from './gas-datapicker-calendar.component';

@Directive({
  selector: '[gasCalendar]',
})
export class GasDatapickerCalendarDirective extends GasDynamicPositioningPopupDirective<void,
  GasDatapickerCalendarComponent> {
  @Input('gasCalendar')
  public set setup(value: Omit<GasPositioningPopup.Config<GasDatapickerCalendarComponent>, 'component'>) {
    this.config = {
      ...this.injectionConfig,
      ...{
        preferablePositions: [
          GasPositioning.Direction.TopRight,
          GasPositioning.Direction.BottomRight,
        ],
      },
      ...value,
      component: GasDatapickerCalendarComponent,
    };

    this.nativeDisabled = value?.disabled;
  }

  /** Без модификаторов доступа, ибо они указаны в расширяемом классе */
  constructor(
    el: ElementRef,
    gasDynamicComponentsService: GasDynamicComponentsService,
    gasPositioningService: GasPositioningService,
    gasBrowserEventsService: GasBrowserEventsService,
    render: Renderer2,
    @Inject(GAS_POSITIONING_CONFIG)
    private injectionConfig: GasPositioningPopup.Config<GasDatapickerCalendarComponent>,
  ) {
    super(
      el,
      gasDynamicComponentsService,
      gasPositioningService,
      gasBrowserEventsService,
      render,
    );
  }
}
